export default {
  momentLocale: 'th',
  Timeline: {
    expand: 'แสดง',
    fold: 'ปิด',
  },
  Balloon: {
    close: 'ปิด',
    confirm: 'ตกลง',
    cancel: 'ยกเลิก',
  },
  Card: {
    expand: 'แสดง',
    fold: 'ปิด',
  },
  Calendar: {
    today: 'วันนี้',
    now: 'ณ จุดนี้',
    ok: 'ยืนยัน',
    clear: 'ล้างค่า',
    month: 'เดือน',
    year: 'ปี',
    prevYear: 'ปีที่แล้ว',
    nextYear: 'ปีหน้า',
    prevMonth: 'เดือนที่แล้ว',
    nextMonth: 'เดือนหน้า',
    prevDecade: '十二ปีที่แล้ว',
    nextDecade: 'ในอีก 12 ปี',
    yearSelectAriaLabel: 'เลือกปี',
    monthSelectAriaLabel: 'เลือกเดือน',
    format: {
      months: '1 เดือน_2 เดือน_3 เดือน_4 เดือน_5 เดือน_6 เดือน_7 เดือน_8 เดือน_9 เดือน_10 เดือน_11 เดือน_12 เดือน'.split(
        '_',
      ),
      shortMonths: '1 เดือน_2 เดือน_3 เดือน_4 เดือน_5 เดือน_6 เดือน_7 เดือน_8 เดือน_9 เดือน_10 เดือน_11 เดือน_12 เดือน'.split(
        '_',
      ),
      weekdays: 'วันอาทิตย์_วันจันทร์_วันอังคาร_วันพุธ_วันพฤหัสบดี_วันศุกร์_วันเสาร์'.split('_'),
      shortWeekdays: 'วันอาทิตย์_วันจันทร์_วันอังคาร_วันพุธ_วันพฤหัสบดี_วันศุกร์_วันเสาร์'.split(
        '_',
      ),
      veryShortWeekdays: 'วันอาทิตย์_วันจันทร์_วันอังคาร_วันพุธ_วันพฤหัสบดี_วันศุกร์_วันเสาร์'.split(
        '_',
      ),
      yearLabel: 'ปี YYYY',
    },
  },
  DatePicker: {
    placeholder: 'โปรดเลือกวันที่',
    datetimePlaceholder: 'โปรดเลือกวันที่และเวลา',
    monthPlaceholder: 'โปรดเลือกเดือน',
    yearPlaceholder: 'โปรดเลือกปี',
    now: 'ณ จุดนี้',
    selectTime: 'เลือกเวลา',
    selectDate: 'เลือกวันที่',
    ok: 'ยืนยัน',
    clear: 'ล้างค่า',
    startPlaceholder: 'วันเริ่มต้น',
    endPlaceholder: 'วันสิ้นสุด',
    hour: 'เวลา',
    minute: 'นาที',
    second: 'วินาที',
  },
  Dialog: {
    close: 'ปิด',
    ok: 'ตกลง',
    cancel: 'ยกเลิก',
  },
  Message: {
    closeAriaLabel: 'ปิด',
  },
  Pagination: {
    goTo: 'ไปยัง',
    page: 'หน้า',
    total: 'หน้า {current} จากทั้งหมด {total} หน้า',
    labelPrev: 'หน้าก่อนหน้า หน้าปัจจุบัน {current}',
    labelNext: 'หน้าถัดไป หน้าปัจจุบัน {current}',
    inputAriaLabel: 'โปรดป้อนหมายเลขหน้าที่คุณต้องการกระโดดไป',
    selectAriaLabel: 'โปรดเลือกจำนวนที่จะแสดงในแต่ละหน้า',
    pageSize: '行/หน้า',
  },
  Input: {
    clear: 'ล้างข้อมูล',
  },
  Select: {
    selectPlaceholder: 'โปรดเลือก',
    autoCompletePlaceholder: 'โปรดป้อนข้อมูล',
    notFoundContent: 'ไม่มีตัวเลือก',
    maxTagPlaceholder: 'เลือกแล้ว {selected}/{total} รายการ',
  },
  Table: {
    empty: 'ไม่มีข้อมูล',
    ok: 'ตกลง',
    reset: 'รีเซ็ต',
    asc: 'เพิ่มขึ้นตามลำดับ',
    desc: 'เรียงลำดับถดถอย',
    expanded: 'ขยาย',
    folded: 'พับแล้ว',
    filter: 'กรอง',
    selectAll: 'เลือกทั้งหมด',
  },
  TimePicker: {
    placeholder: 'โปรดเลือกเวลา',
    startPlaceholder: 'เวลาเริ่มต้น',
    endPlaceholder: 'เวลาสิ้นสุด',
    clear: 'ล้างข้อมูล',
    hour: 'เวลา',
    minute: 'นาที',
    second: 'วินาที',
  },
  Transfer: {
    items: 'รายการ',
    item: 'รายการ',
    moveAll: 'ย้ายทั้งหมด',
    searchPlaceholder: 'โปรดป้อนข้อมูล',
    moveToLeft: 'ถอยเลือกองค์ประกอบ',
    moveToRight: 'ส่ง Элементที่เลือก',
  },
  Upload: {
    card: {
      cancel: 'ยกเลิก',
      addPhoto: 'อัปโหลดรูปภาพ',
      download: 'ดาวน์โหลด',
      delete: 'ลบ',
    },
    drag: {
      text: 'คลิกหรือลากไฟล์ไปยังกล่องเส้นประนีประนอมเพื่ออัปโหลด',
      hint: 'สนับสนุนไฟล์類型เช่น docx, xls, PDF, rar, zip, PNG, JPG และอื่น ๆ',
    },
    upload: {
      delete: 'ลบ',
    },
  },
  Search: {
    buttonText: 'ค้นหา',
  },
  Tag: {
    delete: 'ลบ',
  },
  Rating: {
    description: 'ตัวเลือกการให้คะแนน',
  },
};
